var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 66,
    viewBox: "0 0 61 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4323 65.0996L10.777 42.6794L27.3432 21.6098H40.7922L21.3758 45.3806L21.8212 39.618L41.6829 65.0996H27.4323ZM0 65.0996V0H11.6676V65.0996H0Z",
    fill: "#1C232C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7857 66C51.6481 66 49.8964 65.2797 48.5308 63.839C47.1651 62.3984 46.4822 60.6276 46.4822 58.5266C46.4822 56.4256 47.1651 54.6549 48.5308 53.2142C49.8964 51.7735 51.6481 51.0532 53.7857 51.0532C55.8639 51.0532 57.5858 51.7735 58.9515 53.2142C60.3172 54.6549 61 56.4256 61 58.5266C61 60.6276 60.3172 62.3984 58.9515 63.839C57.5858 65.2797 55.8639 66 53.7857 66Z",
    fill: "#1C232C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.eaeae7794f3d8470832c6f4f8dfd5812.svg";
export { ForwardRef as ReactComponent };